import * as z from 'zod';

export const EscalationDetailsSchema = z.object({
  id: z.union([z.number(), z.string()]), // search returns a string, while MTBE returns a number
  code: z.string(),
  title: z.string(),
});

export type EscalationDetails = z.infer<typeof EscalationDetailsSchema>;
